import { Box, Typography } from "@mui/material";
import { toToman } from "../../utils/Utils";
import StartDirectDebit from "../../assets/images/start-direct-debit.svg";
import { ReactComponent as ArrowLeftGreen } from "../../assets/icons/arrow-left-green.svg";
import { useNavigate } from "react-router-dom";

function StartDirectDebitBanner({ sx = [], ...props }) {
  const navigate = useNavigate();
  return (
    <Box
      onClick={() => {
        navigate("/app/direct-debit");
      }}
      sx={{
        width: "100%",
        p: "12px",
        borderRadius: "12px",
        boxShadow: (theme) => theme.shadows[3],
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography align="right" variant="subtitle1" color="grey.2">
        پول‌های کوچک خود را بدون دردسر پس‌انداز کنید
      </Typography>
      <Box
        sx={{
          mt: "8px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <img src={StartDirectDebit} width={112} height={68} />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" color="primary.main">
            پس‌انداز خودکار
          </Typography>
          <ArrowLeftGreen width={18} height={18} />
        </Box>
      </Box>
    </Box>
  );
}

export default StartDirectDebitBanner;
